import { StyleSheet } from '@react-pdf/renderer';
import certificateImg from 'src/assets/images/certificate.png';

const styles = StyleSheet.create({
	page: {
		flexDirection: 'row',
		backgroundColor: '#fff',
		width: '100%',
		height: '100%',
		orientation: 'landscape',
	},
	view: {
		width: '100%',
		height: '100%',
		padding: 0,
		backgroundColor: 'white',
	},
	image: {
		marginTop: 0,
		objectFit: 'cover',
	},
	name: {
		width: '100%',
		position: 'absolute',
		top: '39%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: 28,
		fontWeight: 'bold',
		textAlign: 'center',
		color: '#000',
	},
	institutionContainer: {
		width: 482,
		position: 'absolute',
		top: '46%',
		left: 333,
	},
	courseName: {
		// width: '100%',
		// position: 'absolute',
		// top: '65%',
		// left: 300,
		// display: 'flex',
		// alignItems: 'center',
		// justifyContent: 'center',
		fontSize: 16,
		// fontWeight: 'bold',
		textAlign: 'left',
		// width: 490
	},
	institutionName: {
		// width: '100%',
		// position: 'absolute',
		// top: '47%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: 16,
		// fontWeight: 400,
		textAlign: 'left',
	},
	departmentContainer: {
		paddingTop: 6,
		width: 452,
		// display: 'flex',
		// flexDirection: 'row',
		// alignItems: 'center',
		// justifyContent: 'space-between',
	},
	department: {
		// width: '100%',
		// position: 'absolute',
		// top: '51%',
		// display: 'flex',
		// alignItems: 'center',
		// justifyContent: 'center',
		fontSize: 16,
		// fontWeight: 400,
		textAlign: 'left',
	},
	time: {
		fontSize: 16,
		fontWeight: 'normal',
		textAlign: 'left',
		width: '100%',
	},
	courseContainer: {
		position: 'absolute',
		top: '63%',
		left: 333,
		width: 458,
	},
	courseDataContainer: {
		paddingTop: 4,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		position: 'relative',
		width: '100%',
	},
	dateContainer: {
		position: 'absolute',
		top: 20,
		right: 60,
		width: 350,
		textAlign: 'right',
	},
	date: {
		fontSize: 16,
		textAlign: 'right',
	},
});

export default styles;
